import { render } from "./editProfilePanel.vue?vue&type=template&id=84a8a60e"
import script from "./editProfilePanel.vue?vue&type=script&lang=js"
export * from "./editProfilePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__